export function parseUserActive(value) {
  return value === true || value === 1;
}
